<template>
    <div class="content-wrapper">
        <modals-container @confirm="confirmDeleteJob"></modals-container>
        <div class="page-heading">
            <div class="page-content fade-in-up">
                <div class="row">
                    <div class="col-md-12">
                        <div class="ibox">
                            <div class="ibox-body">
                                <ul class="nav nav-tabs tabs-line">
                                    <li class="nav-item">
                                        <a @click="clearUpdate" v-if="checkUrl()" id="jobsList" class="nav-link active" href="#tab-1" data-toggle="tab">{{$t('message.listOfWork')}}</a>
                                        <a @click="clearUpdate" v-else id="jobsList" class="nav-link active" href="#tab-1" data-toggle="tab">{{$t('message.listOfBkp')}}</a>
                                         
                                    </li>
                                    <li v-if="!updateJob" class="nav-item">
                                        <a v-if="checkUrl()" class="nav-link" href="#tab-2" data-toggle="tab">{{$t('message.addNewWork')}}</a>
                                        <a v-else class="nav-link" href="#tab-2" data-toggle="tab">{{$t('message.addNewBkp')}}</a>
                                    </li>
                                    <li v-if="updateJob" class="nav-item">
                                        <a id="updateJob" v-if="checkUrl()" class="nav-link" href="#tab-2" data-toggle="tab">{{$t('message.updateWork')}}</a>
                                        <a id="updateJob" v-else class="nav-link" href="#tab-2" data-toggle="tab">{{$t('message.updateBkp')}}</a>
                                    </li>
                                </ul>
                                <div class="tab-content">
                                    <div id="tab-1" class="tab-pane fade active show">
                                        <div class="row">
                                            <div class="col-md-12">
                                                <div class="row">
                                                    <div class="col-md-12">
                                                        <div class="table-responsive">
                                                            <table class="table table-striped">
                                                                <thead>
                                                                <tr>
                                                                    <th></th>
                                                                    <th v-if="checkUrl()">{{$t('message.theNameOfWork')}}</th>
                                                                    <th v-else>{{$t('message.theNameOfBkp')}}</th>
                                                                    <th v-if="checkUrl()">{{$t('message.workDescription')}}</th>
                                                                    <th v-else>{{$t('message.bkpDescription')}}</th>
                                                                    <th style="text-align:right"><button class="btn view" @click="sortBkp()"><i class="fa" v-bind:class="[isArrowDown ? 'fa-sort-asc' : 'fa-sort-desc']"></i></button></th>
                                                                </tr>
                                                                </thead>
                                                                <tbody v-if="jobs.length !== 0">
                                                                <tr
                                                                        v-for="(data, index) in jobs" :key="index">
                                                                    <th scope="row">{{index + 1}}</th>
                                                                    <td>{{data.name}}</td>
                                                                    <td>{{data.description}}</td>
                                                                    <td class="text-right">
                                                                        <a @click="setUpdate(data.name, data.id, data.description)" href="#tab-2" data-toggle="tab"
                                                                                data-original-title="Edit"
                                                                                class="btn btn-default btn-xs m-r-5"><i
                                                                                class="fa fa-pencil font-14"></i>
                                                                        </a>
                                                                        <button @click="deleteJob(data.id, data.name)"
                                                                                data-toggle="tooltip"
                                                                                data-original-title="Delete"
                                                                                class="btn btn-default btn-xs"><i
                                                                                data-v-2fbef3e4=""
                                                                                class="fa fa-trash font-14"></i>
                                                                        </button>
                                                                    </td>
                                                                </tr>
                                                                </tbody>
                                                            </table>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div id="tab-2" class="tab-pane fade active-show">
                                        <div class="row">
                                            <div class="col-md-12 ">
                                                <div class="row">
                                                    <div class="col-md-4">
                                                    </div>
                                                    <div class="col-md-4">
                                                        <div class="form-group">
                                                            <label v-if="checkUrl()">{{$t('message.theNameOfWork')}}</label>
                                                            <label v-else >{{$t('message.theNameOfBkp')}}</label>
                                                            <input v-if="checkUrl()" class="form-control"
                                                                   type="text" v-model="job"
                                                                   :placeholder="$t('message.theNameOfWork')"> 
                                                            <input v-else class="form-control"
                                                                   type="text" v-model="job"
                                                                   :placeholder="$t('message.theNameOfBkp')"> 
                                                        </div>
                                                        <div class="form-group">
                                                            <label v-if="checkUrl()">{{$t('message.workDescription')}}</label>
                                                            <label v-else>{{$t('message.bkpDescription')}}</label>
                                                            <input v-if="checkUrl() " class="form-control"
                                                                   type="text" v-model="description"
                                                                   :placeholder="$t('message.workDescription')">
                                                            <input v-else class="form-control"
                                                                   type="text" v-model="description"
                                                                   :placeholder="$t('message.bkpDescription')">
                                                            
                                                        </div>
                                                        <div class="row">
                                                            <div class="col-md-12 text-left pt-2">
                                                                <button v-if="!updateJob" @click="addJob" class="btn btn-primary">
                                                                    {{$t('message.add')}}
                                                                </button>
                                                                <button v-if="updateJob" @click="editJob" class="btn btn-primary">
                                                                    {{$t('message.update')}}
                                                                </button>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>

                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
  import OkModal     from '../../modals/OkModal';
  import DialogModal from '../../modals/DialogModal';

  export default {
    name: 'Jobs',
    data () {
      return {
        job: '',
        description:'',
        jobId: null,
        jobs: [],
        updateJob: false,
        isArrowDown: false
      }
    },
    mounted () {
      let self = this

      this.getList(this.apiPrefix, this.jobApiUrl)
        .then(resp => {
          self.jobs = resp.data
        }).catch(err => {
        console.log(err)
      })
    },
    methods: {
      sortBkp(){
          this.isArrowDown = !this.isArrowDown;
          
          if(this.isArrowDown)
            this.jobs.sort(this.dynamicSort("-name"))
          else
            this.jobs.sort(this.dynamicSort("name"))
      },
      dynamicSort(property) {
          let sortOrder = 1;
          if(property[0] === "-") {
              sortOrder = -1;
              property = property.substr(1);
          }
          return function (a,b) {
              let result = (a[property] < b[property]) ? -1 : (a[property] > b[property]) ? 1 : 0;
              return result * sortOrder;
          }
      },
      editJob(){
        let self = this;

        this.update(this.apiPrefix, this.jobApiUrl, this.jobId, {
          name: this.job,
          description: this.description
        })
          .then(() => {
            self.$modal.show(OkModal, {
              text: self.$t('message.jobUpdatedSuccessfully'),
              modalClass: self.modalClasses.okSuccessClass
            },
            {
              width: self.modalWidth(),
              height: 'auto'
            })

            self.jobs = self.jobs.map(obj => {
              if(obj.id === self.jobId) {
                obj.name = self.job;
                obj.description = self.description;
              }
              return obj;
            })

            // self.job = '';

            this.getList(this.apiPrefix, this.jobApiUrl)
              .then(resp => {
                self.jobs = resp.data
              }).catch(err => {
              console.log(err)
            })

          }).catch(err => {
            console.log(err);
        });
      },
      clearUpdate() {
        this.updateJob = false;
        this.job = '';
        this.description = '';

        const tab2 = document.getElementById('tab-2');
        tab2.classList.remove('active');
      },
      setUpdate(name, id, description){
        this.updateJob = true;
        this.job = name;
        this.description = description;
        this.jobId = id;

        const jobsList = document.getElementById('jobsList');
        jobsList.classList.remove('active');
      },
      confirmDeleteJob(jobId) {
        let self = this;
        this.delete(this.apiPrefix, this.jobApiUrl, jobId).then(() => {
          self.jobs = self.jobs.filter(obj => {
            return obj.id !== jobId;
          });
        }).catch(err => {
          console.log(err);
        })
      },
      deleteJob (param, name) {
        this.$modal.show(DialogModal, {
            text: `${this.$t('message.confirmDelete')} ${name}?`,
            param: param,
            event: 'confirm'
          },
          {
            width: this.modalWidth(),
            height: 'auto'
          })
      },
      addJob () {
        let self = this
        this.post(this.apiPrefix, this.jobApiUrl, '', {
          name: this.job,
          description: this.description
        }).then(resp => {
          self.$modal.show(OkModal, {
              text: self.$t('message.jobCreatedSuccessfully'),
              modalClass: self.modalClasses.okSuccessClass
            },
            {
              width: self.modalWidth(),
              height: 'auto'
            })

          self.jobs.push(resp.data.object);
        }).catch(err => {
          let errMsg = self.firstLetterLowerCase(self.toTitleCase(err.response.data.name[0], ' '))
          errMsg = errMsg.substring(0, errMsg.length - 1)

          self.$modal.show(OkModal, {
              text: self.$t(`message.${errMsg}`),
              modalClass: self.modalClasses.okErrorClass
            },
            {
              width: self.modalWidth(),
              height: 'auto'
            })
        })
        this.job = null
        this.description = null
      }

    }
  }
</script>

<style scoped>
label{
        font-weight: bold;
    }
</style>